import React, { useContext } from "react";
import { FlashMessages, RenderProps } from "./index";

export const FlashMessagesContext = React.createContext<RenderProps>({
  messages: [],
  add: () => {},
  close: () => {},
  closeAll: () => {},
});

export const FlashMessagesProvider = (
  props: React.PropsWithChildren<Omit<FlashMessages["props"], "children">>
) => (
  <FlashMessages {...props}>
    {(renderProps) => (
      <FlashMessagesContext.Provider value={renderProps}>
        {props.children}
      </FlashMessagesContext.Provider>
    )}
  </FlashMessages>
);

export function useFlashMessages() {
  return useContext(FlashMessagesContext);
}
